import { Pipe, PipeTransform, inject } from '@angular/core';
import { MarkdownService, MarkedOptions, MarkedRenderer } from 'ngx-markdown';

export interface MarkdownLinkConfig {
  currentHostName?: string;
}

@Pipe({ name: 'glxyMarkdown'})
export class GlxyMarkdownPipe implements PipeTransform {
  private markdownService = inject(MarkdownService);

  transform(message: string | null | undefined, config?: MarkdownLinkConfig): string {
    if (!message) {
      return '';
    }

    if (config?.currentHostName) {
      const renderer = this.createCustomLinkRenderer(config);
      return this.markdownService.parse(message, {
        markedOptions: {
          ...(this.markdownService.options as MarkedOptions),
          renderer,
        },
      }) as string;
    }

    return this.markdownService.parse(message) as string;
  }

  private createCustomLinkRenderer(config: MarkdownLinkConfig): MarkedRenderer {
    const renderer = new MarkedRenderer();
    const currentDomain = this.getDomainFromHostName(config.currentHostName || '');

    renderer.link = (href: string, title: string, text: string) => {
      const isInternal = this.isSameDomain(href, currentDomain);
      const targetAttr = isInternal ? '' : ' target="_blank" rel="noopener noreferrer"';
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${href}"${titleAttr}${targetAttr}>${text}</a>`;
    };

    return renderer;
  }

  private isSameDomain(href: string, currentDomain: string): boolean {
    if (href.startsWith('/') || href.startsWith('#') || href.startsWith('?')) {
      return true;
    }

    const lowerHref = href.toLowerCase();
    return lowerHref.includes(currentDomain);
  }

  private getDomainFromHostName(hostName: string): string {
    return hostName.replace(/^(https?:\/\/)?(www\.)?/i, '').toLowerCase();
  }
}
